import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Structure, FormatCurrency, AutoResizeInput } from '@/common/helpers/structure.helper'
import { dataLink } from '@/common/interfaces/Links.interface'

@Component({})
export class LinksConfig extends Vue {

    public helper = new Structure();
    public helperFormat = new FormatCurrency();
    public checkClientType: boolean = false;
    public linkItems: any = [];

    public itemSctructure: dataLink = {
        //status: 0 = inativo / 1 = ativo / 2 = standby
        status: 2
        , name: ''
        , url: ''
        , icon: {
            status: false
            , class: 'fas fa-hands'
            , name: 'home'
            , bgColor: '#f20'
            , txtColor: '#FFF'
        }
        , flag: {
            status: false
            , class: 'green'
            , text: ''
            , colors: false
            , actions: true
            , customClass: 'badge-success'
        }
        , whats: {
            status: false
            , link: 'https://wa.me/55'
            , text: 'Olá! Te encontramos pela connect4sell'
            , numero: ''
        }
    }


    @Prop({ default: undefined })
    public data: any;

    mounted(){
        this.addItem()
    }

    created() {
        if (this.data.length) {
            this.linkItems = this.data;
        }
    }

    public actionOptions(item: dataLink){
        item.flag.status  = false;
        item.whats.status = false;
    }

    public setTxtFlag(e: any){
        console.log('> ', e);
    }

    public setColorFlag(e: any){
        console.log('>> ',e);
    }

    public addItem() {
        this.linkItems.push((JSON.parse(JSON.stringify(this.itemSctructure))));
    }

    public deleteItem(id: number) {
        if (this.linkItems.length > 1) {
            this.linkItems.splice(id, 1)
        }
    }

    public openWhats(item: dataLink) {
        if (item.status > 0) {
            item.whats.status   = true;
            item.flag.status    = false;
        }
    }

    public buttonFlag(item: dataLink){
        if (item.status > 0) {
            item.whats.status   = false;
            item.flag.status    = true;
        }
    }

    public activeItems(id: number) {
        switch (this.linkItems[id].status) {
            case 1:
                this.linkItems[id].status = 0
                break;

            case 0:
                this.linkItems[id].status = 1
                break;

            case 2:
                this.linkItems[id].status = 1
                break;
        }
    }

    public expiredItem(date: Date) {
        if (date) {
            const currentDate = new Date().getTime();
            const futureDate = new Date(date).getTime();

            return currentDate <= futureDate;
        } else {
            return true;
        }
    }
}